import { get, post } from '../Services/http';
import { translate } from '../Services/translation';
import { getUrlQueryParameter } from '../Services/utils';
import { catchError } from './Error.action';
import {
  getFacetFiltersAsQuery,
  receive,
  saveQuery,
  submitSearchFacet,
  updateSubNavigationLinks,
} from './FacetedSearch.action';

export const UPDATE_PAYLOAD = 'UPDATE_PAYLOAD';
export const RECEIVE_CAR_MODEL = 'RECEIVE_CAR_MODEL';
export const ADVANCED_SEARCH_HISTORY = 'ADVANCED_SEARCH_HISTORY';

import {
  ADVANCED_SEARCH_ERROR,
  ADVANCED_SEARCH_RECEIVE_CAR_MODEL,
  ADVANCED_SEARCH_UPDATE_PAYLOAD,
  ADVANCED_SEARCH_SEARCH_TYPE_DIMENSION,
  ADVANCED_SEARCH_SEARCH_TYPE_REGNO,
  ADVANCED_SEARCH_SEARCH_TYPE_CARMODEL,
  ADVANCED_SEARCH_REAR_DIMENSION_QUERY,
  ADVANCED_SEARCH_SET_IS_LOADING_URL,
} from '../constants';
import {
  setProductsInProductsView,
  setProductsLoading,
} from './ProductsView.action';

export const setIsLoadingUrl = (isLoadingUrl) => ({
  type: ADVANCED_SEARCH_SET_IS_LOADING_URL,
  payload: {
    isLoadingUrl,
  },
});

export const setActiveTabAction = (tab) => (dispatch) => {
  dispatch(onAdvancedSearchError({ error: null }));

  return dispatch({
    type: ADVANCED_SEARCH_UPDATE_PAYLOAD,
    payload: {
      activeTab: tab,
    },
  });
};

export const searchDimensions = (data, abortController) => async (dispatch) => {
  dispatch(onAdvancedSearchError({ error: null }));
  dispatch(setIsLoading(true));

  post(
    `/api/advancedsearch/dimensions?licensePlate=${getUrlQueryParameter(
      'licensePlate'
    )}`,
    data,
    abortController
  )
    .then((res) => res.json())
    .then((model) => {
      const dimensionsModel = model?.dimensions;

      if (dimensionsModel?.facetSearchResult && data.includeProducts) {
        var query = buildDimensionQuery(dimensionsModel);
        addToSearchHistory(
          ADVANCED_SEARCH_SEARCH_TYPE_DIMENSION,
          query,
          dimensionsModel?.currentCategory?.url
        );
        // Update rear dimension in url query
        dispatch(setRearDimensionsUrlQuery(dimensionsModel));
        // Update facet filters url query
        dispatch(
          saveQuery(
            getFacetFiltersAsQuery(
              dimensionsModel.facetSearchResult.facetFilters
            )
          )
        );
        // Update facet filters state
        dispatch(receive(dimensionsModel.facetSearchResult));
        // Set products
        dispatch(
          setProductsInProductsView(dimensionsModel.facetSearchResult.products)
        );
        dispatch(setProductsLoading(false));
      }

      dispatch({
        type: ADVANCED_SEARCH_UPDATE_PAYLOAD,
        payload: {
          model,
          isLoading: false,
        },
      });
    })
    .catch((err) => {
      dispatch(setIsLoading(false));
      dispatch(catchError(err, onAdvancedSearchError));
    });
};

export const getCarModelVariants = (regNo) => {
  return get(`/api/advancedsearch/carvariants?regNo=${regNo}`).then((res) =>
    res.json()
  );
};

export const getUrlForCarModelVariant = (
  carModelVariantSystemId,
  regNo = null
) => (dispatch) => {
  dispatch(setIsLoading(true));
  dispatch(onAdvancedSearchError({ error: null }));
  dispatch(setIsLoadingUrl(true));

  return post(
    `/api/advancedsearch/carvariant?carModelVariantSystemId=${carModelVariantSystemId}`
  )
    .then((res) => res.text())
    .then((url) => {
      addToSearchHistory(
        ADVANCED_SEARCH_SEARCH_TYPE_REGNO,
        regNo?.toUpperCase(),
        url
      );

      if (url && url.length > 0) {
        location.href = url;
      } else {
        dispatch(setIsLoading(false));
        dispatch(setIsLoadingUrl(false));
      }
    })
    .catch((err) => {
      dispatch(setIsLoading(false));
      dispatch(setIsLoadingUrl(false));
      dispatch(catchError(err, onAdvancedSearchError));
    });
};

export const receiveCarModel = (carModel) => ({
  type: ADVANCED_SEARCH_RECEIVE_CAR_MODEL,
  payload: carModel,
});

export const searchCarModel = (
  { brand, series, model, variant },
  redirect = true,
  triggerLoading = true
) => (dispatch) => {
  dispatch(onAdvancedSearchError({ error: null }));
  triggerLoading && dispatch(setIsLoading(true));

  if (variant && triggerLoading) {
    dispatch(setIsLoadingUrl(true));
  }

  return post(`/api/advancedsearch/carmodel`, { brand, series, model, variant })
    .then((res) => res.json())
    .then((carModel) => {
      dispatch(receiveCarModel(carModel));

      addToSearchHistory(
        ADVANCED_SEARCH_SEARCH_TYPE_CARMODEL,
        carModel.searchInfo,
        carModel.modelCategoryUrl
      );

      if (carModel.modelCategoryUrl && redirect) {
        location.href = carModel.modelCategoryUrl;
      } else if (triggerLoading) {
        dispatch(setIsLoading(false));
        dispatch(setIsLoadingUrl(false));
      }
    })
    .catch((err) => {
      dispatch(catchError(err, onAdvancedSearchError));
      triggerLoading && dispatch(setIsLoading(false));
    });
};

export const setIsLoading = (isLoading) => ({
  type: ADVANCED_SEARCH_UPDATE_PAYLOAD,
  payload: {
    isLoading,
  },
});

export const addToSearchHistory = (type, query, redirectUrl = '') => {
  if (type && query) {
    var storedHistory = localStorage.getItem(ADVANCED_SEARCH_HISTORY);
    var searchHistoryModel = storedHistory ? JSON.parse(storedHistory) : [];
    var category = translate('advanced.search.history.' + type.toLowerCase());
    var currentDate = new Date();
    var dateOfSearch = currentDate.toLocaleString('sv-SE');

    var model = {
      date: dateOfSearch,
      type: category,
      query: query,
      redirect: redirectUrl,
    };

    if (searchHistoryModel.length > 25) {
      searchHistoryModel.pop();
    }

    searchHistoryModel.push(JSON.stringify(model));

    localStorage.setItem(
      ADVANCED_SEARCH_HISTORY,
      JSON.stringify(searchHistoryModel)
    );
  }
};

export const buildDimensionQuery = (dimensionsModel) => {
  return `${dimensionsModel.width} ${
    dimensionsModel.profile ? ' / ' + dimensionsModel.profile : ''
  } ${dimensionsModel.rimDiameter ? ' R' + dimensionsModel.rimDiameter : ''} 
            ${translate('general.for').toLowerCase()}
            ${dimensionsModel.currentCategory.name}`;
};

const onAdvancedSearchError = (errorModel) => ({
  type: ADVANCED_SEARCH_ERROR,
  payload: {
    error: errorModel.error,
  },
});

export const setRearDimensionsUrlQuery = (dimensions) => ({
  type: ADVANCED_SEARCH_REAR_DIMENSION_QUERY,
  payload: {
    dimensions,
  },
});
